import { Box, InlineValidation } from "@nulogy/components";
import { useField, useFormikContext } from "formik";
import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./DatePicker.styles.scss";

function DatePicker({
  labelText,
  field: name,
  className,
  onChange,
  placeholderText,
  disabled,
  dateFormat = "MMMM d, yyyy h:mm a",
}) {
  const { setFieldValue, errors } = useFormikContext();
  const [field, _meta, helpers] = useField(name);

  const handleChange = (value) => {
    //  NOTE: This control assumes that date is mandatory
    if (!value) return;

    if (onChange) {
      onChange({ setFieldValue, value });
    }
    helpers.setValue(value);
  };

  return (
    <>
      {/* biome-ignore lint/a11y/noLabelWithoutControl: ReactDatePicker should be an input */}
      <label className={className}>
        <Box className="datepicker-label" data-testid="datepicker-label" marginBottom="x1">
          {labelText}
        </Box>
        <ReactDatePicker
          dateFormat={dateFormat}
          disabled={disabled}
          name={name}
          onChange={handleChange}
          placeholderText={placeholderText}
          popperProps={{ strategy: "fixed" }}
          selected={field.value ? new Date(field.value) : null}
          showTimeSelect
          timeCaption="time"
          timeFormat="h:mm a"
          timeIntervals={15}
          wrapperClassName={errors[name] ? "datepicker-input-error" : ""}
        />
        {errors[name] && <InlineValidation errorMessage={errors[name]} mt="x1" />}
      </label>
    </>
  );
}

export default React.memo(DatePicker);
